import { render, staticRenderFns } from "./multipane-resizer.vue?vue&type=template&id=8568638e"
import script from "./multipane-resizer.vue?vue&type=script&lang=ts"
export * from "./multipane-resizer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports